import { Outlet } from 'react-router-dom'
import { TopNavbar } from './TopNavbar'

const Layout = (): JSX.Element => {
  return (
    <div className={'min-h-screen w-screen flex flex-col relative'}>
      <main className={'h-full w-full'}>
        <div className="flex flex-col">
          <TopNavbar />
          <main className={'min-w-screen bg-white min-w-full'}>
            <div className={'min-w-screen h-full w-full'}>
              <Outlet />
            </div>
          </main>
        </div>
      </main>
    </div>
  )
}

export default Layout
